import React from 'react';
import PropTypes from 'prop-types';

import StatePageAccordion, {
  AccordionGroup,
} from '~components/common/Accordion/StatePageAccordion';

import { ContentSection } from '~components/Layout';
import Markdown from '~components/common/Markdown';
import {
  canIUseStudentId,
  canIVoteEarly,
  canIVoteInPerson,
  howDoIKnowIfMyProvisionalBallotWasCounted,
  whatDoINeedToBringToThePolls,
  whereDoIVote,
} from '~utils/faqAnswersInPersonVoting';
import { electionsByMailOnly } from '~utils/faqAnswerUtils';

function StateInPersonVotingInfo({ state, info }) {
  const hasInPersonVoting = !electionsByMailOnly.includes(state.code);

  return (
    <ContentSection width='mid' isZebraStriped>
      <a id='in-person-voting' aria-hidden='true' />
      <h2 className='mt-0'>{`${state.name} voting guide`}</h2>

      <AccordionGroup>
        {hasInPersonVoting ? (
          <>
            <StatePageAccordion heading='Can I vote early?'>
              <Markdown content={canIVoteEarly(info, state.name, state.code)} />
            </StatePageAccordion>
            <StatePageAccordion heading='Where do I vote?'>
              <Markdown content={whereDoIVote(info, state.name, state.code)} />
            </StatePageAccordion>
            <StatePageAccordion heading='What type of ID do I need to show when I vote?'>
              <Markdown content={whatDoINeedToBringToThePolls(info)} />
            </StatePageAccordion>
            <StatePageAccordion heading='Can I use my student ID as identification when voting?'>
              <Markdown content={canIUseStudentId(info)} />
            </StatePageAccordion>
            <StatePageAccordion heading='I cast a provisional ballot. How do I know if it was counted?'>
              <Markdown
                content={howDoIKnowIfMyProvisionalBallotWasCounted(
                  info,
                  state.name,
                  state.code
                )}
              />
            </StatePageAccordion>
          </>
        ) : (
          <StatePageAccordion
            heading={`Can I vote in person in ${state.name}?`}
          >
            <Markdown
              content={canIVoteInPerson(info, state.name, state.code)}
            />
          </StatePageAccordion>
        )}
      </AccordionGroup>
    </ContentSection>
  );
}

StateInPersonVotingInfo.propTypes = {
  state: PropTypes.object,
  info: PropTypes.object,
};

export default StateInPersonVotingInfo;
